import * as React from 'react';

export const ClassicDisplayIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='124'
    height='124'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <path
      d='M15.5008 8.50066L15.5006 11.5007L15.5006 14.5007L9.50062 14.5007L9.50062 8.50066L15.5008 8.50066ZM7.49978 8.50066L7.49978 14.5007L1.49978 14.5007L1.49978 8.50075L7.49978 8.50066ZM15.5006 17.0007L15.5006 23.0007L9.50062 23.0007L9.50062 17.0007L15.5006 17.0007ZM7.49955 17.0007L7.49978 23.0007L1.49978 23.0008L1.49955 17.0007L7.49955 17.0007ZM14.0008 18.5007L11.0008 18.5007L11.0008 21.5007L14.0008 21.5007L14.0008 18.5007ZM6 18.5007L3 18.5007L3 21.5007L6 21.5007L6 18.5007ZM14.0008 10.0007L11.0008 10.0007L11.0008 13.0007L14.0008 13.0007L14.0008 10.0007ZM6 10.0007L3 10.0007L3 13.0007L6 13.0007L6 10.0007Z'
      fill='#004F9F'
    />
    <path
      d='M15.5 5.50089L9.5 5.50088L9.5 4L15.5 4L15.5 5.50089Z'
      fill='#004F9F'
    />
    <path
      d='M7.49955 5.50089L1.49955 5.50097L1.49955 4.00009L7.49955 4L7.49955 5.50089Z'
      fill='#004F9F'
    />
    <path
      d='M24 17.0008L20 23.0021L16.5 17.0008L18 17.0008L19.4 19.5018L19.45 4L20.9 4L20.849 19.5018L22.5 17.0008L24 17.0008Z'
      fill='#004F9F'
    />
  </svg>
);
